export default "__VITE_ASSET__6SkpVzjj__"